// eslint-disable-next-line import/no-cycle
import { IReducerState } from 'store/main-reducer';
import {
  IExtra, ICity, PayCycleOptions, Bank, IPlan, IFlowOptions,
} from 'types';
import { CRMOptionSetValue, CRMSimpleItem } from './crmTypes';

function flattenCRMOptionSetValue(optionSetValue?: CRMOptionSetValue[]): string[] {
  if (!optionSetValue) {
    return [];
  }

  return optionSetValue.map(({ name }) => name);
}

function flattenCRMSimpleItem(simpleItem?: CRMSimpleItem[]): string[] {
  if (!simpleItem) {
    return [];
  }

  return simpleItem.map(({ name }) => name);
}

export const getIsOptionsLoading = (state: IReducerState): boolean => state.optionsReducer.isLoading;

export const getBankOptions = (state: IReducerState): Bank[] => state.optionsReducer.options?.bankOptions || [];

export const getManageHrOptions = (state: IReducerState): string[] => flattenCRMOptionSetValue(state.optionsReducer.options?.manageHrOptions);

export const getJobTitles = (state: IReducerState): string[] => flattenCRMOptionSetValue(state.optionsReducer.options?.jobTitles);

export const getManagePayCycleOptions = (state: IReducerState): PayCycleOptions[] => state.optionsReducer.options?.managePayCycleOptions || [];

export const getHasLoadedOptions = (state: IReducerState): boolean => state.optionsReducer.hasLoadedOptions;

export const getPlans = (state: IReducerState): IPlan[] => state.optionsReducer.options?.plans || [];
export const getExtras = (state: IReducerState): IExtra[] => state.optionsReducer.options?.extras || [];
export const getIndustryTypeOptions = (state: IReducerState): string[] => flattenCRMSimpleItem(state.optionsReducer.options?.industryTypes);

export function getCompetingProducts(state: IReducerState): string[] {
  return flattenCRMSimpleItem(state.optionsReducer.options?.competingProducts);
}
export function getProcessingPayrollOptions(state: IReducerState): string[] {
  return flattenCRMOptionSetValue(state.optionsReducer.options?.payrollProcessingModes);
}

export function getPayePaymentsFrequencyOptions(state: IReducerState): string[] {
  return flattenCRMOptionSetValue(state.optionsReducer.options?.irdPaymentFrequencies);
}
export function getLeaveRolloverOptions(state: IReducerState): string[] {
  return flattenCRMOptionSetValue(state.optionsReducer.options?.employeeLeaveRollover);
}

export function getLeadSourceOptions(state: IReducerState): string[] {
  return flattenCRMSimpleItem(state.optionsReducer.options?.leadSource);
}

export function getAccountantHasAccessToOptions(state: IReducerState): string[] {
  return flattenCRMOptionSetValue(state.optionsReducer.options?.accountantHasAccessTo);
}

export function getPayCycleOptions(state: IReducerState): string[] {
  return flattenCRMOptionSetValue(state.optionsReducer.options?.payCycles);
}

export function getCities(state: IReducerState): ICity[] {
  return state.optionsReducer.options?.cities || [];
}

export function getRegions(state: IReducerState): ICity[] {
  return state.optionsReducer.options?.regions || [];
}

export function getFlowOptions(state: IReducerState): IFlowOptions {
  return state.optionsReducer.options as IFlowOptions;
}

export function getLeadChannels(state: IReducerState) {
  return state.optionsReducer.options?.leadChannels;
}
